"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ant_design_vue_1 = require("ant-design-vue");
const icons_vue_1 = require("@ant-design/icons-vue");
const index_vue_1 = __importDefault(require("./Header/index.vue"));
const index_vue_2 = __importDefault(require("./HeaderNew/index.vue"));
const index_vue_3 = __importDefault(require("./SearchBox/index.vue"));
const index_vue_4 = __importDefault(require("./SearchPlie/index.vue"));
exports.default = {
    install(app) {
        //注册antd组件
        app.component("a-dropdown", ant_design_vue_1.Dropdown);
        app.component("a-drawer", ant_design_vue_1.Drawer);
        app.component("a-menu", ant_design_vue_1.Menu);
        app.component("a-menu-item", ant_design_vue_1.Menu.Item);
        app.component("a-avatar", ant_design_vue_1.Avatar);
        app.component("a-select", ant_design_vue_1.Select);
        app.component("a-button", ant_design_vue_1.Button);
        app.component("a-table", ant_design_vue_1.Table);
        app.component("a-input", ant_design_vue_1.Input);
        app.component("a-checkbox", ant_design_vue_1.Checkbox);
        app.component("a-row", ant_design_vue_1.Row);
        app.component("a-col", ant_design_vue_1.Col);
        app.component("a-tooltip", ant_design_vue_1.Tooltip);
        app.component("a-config-provider", ant_design_vue_1.ConfigProvider);
        app.component("a-form", ant_design_vue_1.Form);
        app.component("a-descriptions", ant_design_vue_1.Descriptions);
        app.component("a-breadcrumb", ant_design_vue_1.Breadcrumb);
        //注册antd图标
        app.component("CaretDownOutlined", icons_vue_1.CaretDownOutlined);
        app.component("SearchOutlined", icons_vue_1.SearchOutlined);
        app.component("ArrowLeftOutlined", icons_vue_1.ArrowLeftOutlined);
        app.component("BookOutlined", icons_vue_1.BookOutlined);
        app.component("DownOutlined", icons_vue_1.DownOutlined);
        app.component("UpOutlined", icons_vue_1.UpOutlined);
        app.component("ToolOutlined", icons_vue_1.ToolOutlined);
        app.component("AimOutlined", icons_vue_1.AimOutlined);
        app.component("SafetyOutlined", icons_vue_1.SafetyOutlined);
        //注册公共组件
        app.component("Header", index_vue_1.default);
        app.component("SearchBox", index_vue_3.default);
        app.component("SearchPile", index_vue_4.default);
        app.component("HeaderNew", index_vue_2.default);
    },
};
